import React from "react";
import { Component } from "react";

import { connect } from "react-redux";
import { saveAs } from "file-saver";
import JSZip from "jszip";

class ButtonDownloadGambar extends Component {
  constructor(props) {
    super(props);
    this.laporan_ref = React.createRef();
    this.state = {};
  }
  download_gambar = async () => {
    const { row, fields_image } = this.props;
    const dataRow = row?.row || row;

    // Ambil semua key yang bertipe image
    const fields_images_key = fields_image?.map((f) => {
      return { key: f.key, name: f.name };
    });
    const imageUrls = fields_images_key?.map((d) => {
      return { url: dataRow[d.key], name: d.name };
    });

    if (!imageUrls || imageUrls.length === 0) {
      alert("Tidak ada gambar di baris ini");
      return;
    }

    const zip = new JSZip();
    const folderName =
      dataRow["3ed8c1e9-7d16-441b-83bb-4dbbc6182ad6"]
        .replace(/[<>:"/\\|?*.,]/g, "_")
        .trim() || "dokumentasi_banjir";
    const imgFolder = zip.folder(folderName);

    for (let i = 0; i < imageUrls.length; i++) {
      const url = imageUrls[i].url;
      const name = imageUrls[i].name;
      try {
        const response = await fetch(url, { mode: "cors" });
        if (!response.ok) throw new Error(`Gagal fetch: ${url}`);

        const blob = await response.blob();
        const arrayBuffer = await blob.arrayBuffer();
        imgFolder.file(
          `${name.replace(/[<>:"/\\|?*.,]/g, "_").trim()}.jpg`,
          arrayBuffer
        );
      } catch (err) {
        console.error(`❌ Gagal ambil gambar ${i + 1}`, err);
      }
    }

    // ⏳ generate ZIP setelah semua gambar selesai diambil
    zip.generateAsync({ type: "blob" }).then((zipBlob) => {
      saveAs(zipBlob, `${folderName}.zip`);
    });
  };

  render() {
    return (
      <button
        className="button_small background_black"
        onClick={() => {
          this.download_gambar();
        }}
      >
        Download Gambar
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
});

export default connect(mapStateToProps)(ButtonDownloadGambar);
